<template>
	<div id="ScanBatch">
		<div class="ScanBatch white-light">
			<div class="TopBar dark-stars always-on-top">
				<h4 style="font-size:1em;" class="party float-left"><a href="#" v-if="!partyPaid" v-on:click="cancelParty" class="close-party"><i class="fas fa-times-circle"></i></a> Party {{ partyId }}</h4>
				<h2 class="total float-right dark-stars">${{ parseFloat(partyTotal).toFixed(2) }}</h2>
			</div>
			<div id="theParty" class="aParty">
				<ul>
					<li class="party-user" v-for="(user, key) in sortedUserList()" v-bind:key="key">
						<div class="party-user-info">
							<div class="remove-party-user"><a href="#" v-if="!partyPaid" v-on:click="removeUser(user.user_id)"><i class="fas fa-times"></i></a></div>
							<div class="party-user-image">
								<img v-bind:src="getUserImage(user.user_image)" v-bind:alt="user.user_name" onerror="this.src='images/default_user.jpg'"/>
							</div>
							<h4 class="user-name">{{ user.user_name }}</h4>
						</div>
						<div class="party-user-credentials">
							<div  v-if="user.user_ticket || user.user_ticket_to_purchase" class="party-item-header">Tickets</div>
							<!-- Ticket to Purchase (Party Item with ECT relation)-->
							<PartyItemRow
								v-if="user.user_ticket_to_purchase"
								v-bind:key="user.user_ticket_to_purchase.id"
								:title="user.user_ticket_to_purchase.event_credential_type.title"
								:price="Number(user.user_ticket_to_purchase.total)"
								:fa-icon="'ticket-alt'"
							/>

							<!-- Ticket -->
							<PartyItemRow
								v-if="user.user_ticket"
								v-bind:key="user.user_ticket.event_credential_type_id"
								:title="user.user_ticket.event_credential_type.title"
								:fa-icon="'ticket-alt'"
							/>

							<!-- Lodging -->
							<div v-if="user.user_lodging">
								<PartyItemRow
									:color = "`${user.user_lodging.event_credential_type.does_waive_entry_fees ? 'var(--color-orange)' : ''}`"
									:icon-color = "`${user.user_lodging.event_credential_type.does_waive_entry_fees ? 'var(--color-orange)' : ''}`"
									v-bind:key="user.user_lodging.event_credential_type_id"
									:title="getLodgingCredTitle(user.user_lodging)"
									:fa-icon="'building'"
								/>
								<div v-if="user.user_entry_type !== 'reentry'" class="centered-content">
									<transition>
										<div v-show="user.showFeeWaivedSuccess" class="centered-content" style="color:#ff8d3f;font-weight:bold;font-size:1.5em;max-height:0;">
											Lodger Added!
										</div>
									</transition>
									<div v-if="user.user_lodging.event_credential_type.additional_waived_fees_count > 0">
										<button class="waive-fees-btn btn-warning" v-on:click="openWaiveFeesPopup(user.user_id, user.user_lodging.id)">
												Select Other Lodger: {{parseInt(user.user_lodging.event_credential_type.additional_waived_fees_count)}}
										</button>
									</div>
								</div>
							</div>

							<!-- Fees -->
							<div class="party-item-header"
								v-if="Object.keys(user.entry_fees).length > 0"
							>Fees</div>
							<PartyItemRow
								v-for="(fee) in user.entry_fees"
								v-bind:key="fee.event_credential_type_id"
								:title="fee.title"
								:fa-icon="determinePartyItemIconToDisplay(fee)"
								:price="Boolean(fee.waivedFeeByCredentialId) ? Number(fee.pre_waived_total) : Number(fee.total)"
								:is-waived="Boolean(fee.waivedFeeByCredentialId)"
							/>

							<!-- Only show the checkbox if the user does not have a credential that waives their own fees -->
							<span v-if="isUserALodgerGuest(user)">
								<label class="form-control" style="justify-content: right;">
									<h5 class="waive-fee orange">Lodger Guest</h5>
									<input type="checkbox" v-model="user.is_lodger_for_credential_id" v-on:click="removeLodgerGuest(user)" v-bind:disabled="!!partyPaid">
									<loading-dots v-if="user.isWaivingFees" loading-dots :color="'#ff8d3f'"/>
								</label>
							</span>
						</div>

						<!-- Access -->
						<div class="party-item-header"
							 v-if="Object.keys(user.access).length > 0"
						>Access</div>
						<div v-for="(access, key) in user.access" v-bind:key="key+access.partyItemId">
							<center v-if="access.isRemoving"><loading-dots color="#544098"/></center>
							<PartyItemRow
								v-else
								:title="access.eventCredentialTypeTitle"
								:fa-icon="determinePartyItemIconToDisplay(access)"
								:price="Number(access.total)"
								:is-removable="Boolean(!partyPaid && access.user_can_remove)"
								:remove-data-object="{'user.user_id':user.user_id, 'decal.eventCredentialTypeId': access.eventCredentialTypeId, 'decal.partyItemId': access.partyItemId}"
								@removeItem="removeDecal"
							/>
						</div>

						<!-- Decals -->
						<div class="party-item-header"
							v-if="Object.keys(user.decals).length > 0 || user.lodging_exchanges_for_decals.length > 0"
						>Decals</div>
						<div v-for="(decal, key) in user.lodging_exchanges_for_decals" v-bind:key="key+decal.partyItemId">
							<PartyItemRow
								:title="decal.title"
								:fa-icon="function(){decal.eventCredentialTypeEffectiveScansForType = decal.effective_scans_for_type; return determinePartyItemIconToDisplay(decal);}()"
								:icon-color="determinePartyItemColor(decal.id)"
							/>
						</div>
						<div v-for="(decal, key) in user.decals" v-bind:key="key+decal.partyItemId">
							<center v-if="decal.isRemoving"><loading-dots color="#544098"/></center>
							<PartyItemRow
								v-else
								:title="decal.eventCredentialTypeTitle"
								:fa-icon="determinePartyItemIconToDisplay(decal)"
								:icon-color="determinePartyItemColor(decal.eventCredentialTypeId)"
								:price="Number(decal.total)"
								:is-removable="Boolean(!partyPaid && decal.user_can_remove)"
								:remove-data-object="{'user.user_id':user.user_id, 'decal.eventCredentialTypeId': decal.eventCredentialTypeId, 'decal.partyItemId': decal.partyItemId}"
								@removeItem="removeDecal"
							/>
						</div>

						<div id="DecalAdd" v-if="!partyPaid">
							<button v-if="!user.isDecalAdding" v-on:click="openDecal(user.user_id)"><i class="fas fa-sticky-note"></i> Add Decal</button>
							<loading-dots v-if="user.isDecalAdding"/>
						</div>

					</li>
				</ul>
			</div>

			<div class="BottomBar dark-stars always-on-top">
				<div class="button-row">
					<button v-if="!partyPaid && Object.keys(this.partyUsers).length" v-on:click="verifyCheckout" class="green float-left" id="Collect"><i class="fas fa-usd-circle"></i> Checkout</button>
					<button v-if="!partyPaid" v-on:click="doScan" class="blue float-right" id="Scan"><i class="fas fa-qrcode"></i> Scan</button>
				</div>
			</div>
		</div>

		<!--	Scan User Popup	-->
		<add-user-popup v-if="isAddingUser" @scannedCode="processScan" @close="closeScan" @purchase="loadParty"/>

		<!--	Scanned User Popup	-->
		<div v-if="userFound" class="Scan white-light fullscreen-overlay">
			<div class="closeButton"><a href="#" v-on:click="closeScan"><i class="fas fa-times"></i></a></div>
			<div class="overlay-body">
				<div class="overlay-header text-centered p-1" style="margin-top: 2em;">
					<div>
						<div class="user-image"><img v-bind:src="getUserImage(scannedUser.Image)"  v-bind:alt="scannedUser.Name" onerror="this.src='images/default_user.jpg'"/></div>
					</div>
					<h2>{{ scannedUser.Name }}</h2>
				</div>
				<div class="users-selected-creds">
					<div v-if="!scannedUser.IsReEntry" class="users-selected-creds-list">
						<h5 class="user-cred ticket" v-if="!(scannedUser.Ticket.length < 1 || scannedUser.Ticket == undefined)">
							<i class="fas fa-ticket-alt"></i>
							<span class="cred-type">
								<span class="cred-title">{{ scannedUser.Ticket.event_credential_type.title }}</span>
							</span>
						</h5>
						<h5 class="user-cred lodging" v-if="!(scannedUser.Lodging.length < 1 || scannedUser.Lodging == undefined)">
							<i class="fas fa-building"></i>
							<span class="cred-type">
								<span class="cred-title">{{ getLodgingCredTitle(scannedUser.Lodging) }}</span>
							</span>
						</h5>
						<h5 class="user-cred access" v-for="access in scannedUser.Access" v-bind:key="access.title">
							<i class="fas fa-id-badge"></i>
							<span class="cred-type">
								<span class="cred-title">{{ access.event_credential_type.title }}</span>
							</span>
						</h5>
						<h5 class="user-cred decal" v-for="decal in scannedUser.Decals" v-bind:key="decal.title">
							<i class="fas fa-sticky-note"></i>
							<span class="cred-type">
								<span class="cred-title">{{ decal.event_credential_type.title }}</span>
							</span>
						</h5>
					</div>
					<div v-if="scannedUser.IsReEntry && !scannedUser.isFreeReentry" class="users-selected-creds-list">
						<h5 class="user-cred access">
							<i class="fas fa-id-badge"></i>
							<span class="cred-type">
								<span class="cred-title">{{ $scanner.reEntryFee.title }}</span>
							</span>
						</h5>
					</div>
				</div>
				<div v-if="scannedUser.IsReEntry && scannedUser.isFreeReentry" class="text-centered p-1">
					<h3>-Free Reentry-</h3>
					<button class="green" v-bind:disabled="amAdding" v-on:click="closeScan"><i class="fas fa-plus"></i> Go Back </button>
				</div>
				<div class="button-row" v-else>
					<button class="better-mobile-btn green" v-bind:disabled="amAdding" v-on:click="addUserToParty" id="AddToParty"><i class="fas fa-plus"></i> Add To Party</button>
				</div>
			</div>
		</div>

		<!--	Invalid User Popup	-->
		<div v-if="invalidFound" class="invalidUser fullscreen-centered always-on-top dark-stars">
			<div class="closeButton"><a href="#" v-on:click="closeScan"><i class="fas fa-times"></i></a></div>
			<div>
				<Logo/>
				<div><h2>Invalid</h2></div>
				<div><h5>{{ invalidError }}</h5></div>
				<div class="button-row"><button class="blue" v-on:click="closeScan"><i class="fas fa-mobile-alt"></i> Try Again</button></div>
			</div>
		</div>

		<!--	Add Decal Popup	-->
		<div v-if="decalOpen" class="fullscreen-centered always-on-top white-light">
			<div id="userDecalPopup" class="aParty popup-margins">
				<h2 class="text-centered">Choose a Decal</h2>
				<p class="text-centered">Select a Decal to add. The Decal's barcode can be added during processing.</p>

				<div class="decal-choice text-centered">
					<div class="party-user-info">
						<div class="party-user-image">
							<img v-bind:src="getUserImage(decalDetails.user.user_image)" v-bind:alt="decalDetails.user.name" onerror="this.src='images/default_user.jpg'"/>
						</div>
						<h4 class="user-name">{{ decalDetails.user.user_name }}</h4>
					</div>
				</div>

				<div v-for="decal in Object.values($scanner.availableDecalsMap)" v-bind:key="decal.title">
					<div class="button-row">
						<button class="better-mobile-btn" :style="`background:${decal.color}; color: ${getDecalTextColor(decal.color)}`" v-on:click="addDecal(decalDetails.user.user_id, decal.id)">{{decal.title}} {{ decal.total > 0 ? `- \$${parseFloat(decal.total).toFixed(2)}`: ''}}</button>
					</div>
				</div>

				<div class="button-row"><button class="red better-mobile-btn" v-on:click="closeDecal">Cancel</button></div>
			</div>
		</div>

		<!--	Waive Fees Popup	-->
		<div v-if="showWaiveFeesPopup" class="fullscreen-centered always-on-top white-light">
			<div id="waiveUserPopup" class="aParty popup-margins">
				<h2 class="text-centered">Choose a User</h2>
				<p class="text-centered">Select User to give lodging pass to:</p>

				<div v-for="user in nonLodgingUsers()" v-bind:key="user.user_name">
					<div class="button-row">
						<button class="better-mobile-btn" v-on:click="addLodgingGuest(user)">{{user.user_name}}</button>
					</div>
				</div>

				<div class="button-row"><button class="red better-mobile-btn" v-on:click="closeWaiveFeesPopup">Cancel</button></div>
			</div>
		</div>

		<!--	Collect Cash Popup	-->
		<div v-if="processingCharges" class="processCharges fullscreen-centered always-on-top white-light minheight">
			<div class="closeButton"><a href="#" v-on:click="closeCharges"><i class="fas fa-times"></i></a></div>
			<div>
				<h2>Party Number: {{ this.partyId }}</h2>
				<h2>Collect Money</h2>
				<div id="chargeParty" class="aParty">
					<h6><label>Total:</label> <span>${{ parseFloat(partyTotal).toFixed(2) }}</span></h6>
					<h6><label>Received:</label> <span>$<input type="number" class="money" value="" v-on:change="updateCollectMoneyValues" v-on:keyup="updateCollectMoneyValues" v-on:focus="cashTaken=''" v-model="cashTaken" v-on:keyup.enter="checkoutParty()"/></span></h6>
					<h6><label>Change:</label> <span>${{ parseFloat(cashGiven).toFixed(2) }}</span></h6>
					<div class="button-row"><button class="better-mobile-btn" v-on:click="checkoutParty();"><i class="fas fa-clipboard-list"></i> Process</button></div>
				</div>
			</div>
		</div>

		<!--	Choose Cash or Card Popup	-->
		<div v-if="isChargesModalOpen" class="processCharges fullscreen-centered always-on-top white-light minheight">
			<div class="closeButton"><a href="#" v-on:click="isChargesModalOpen = false"><i class="fas fa-times"></i></a></div>
			<div style="display: flex;flex-flow: column;height: 100%;text-align:center;align-items: center;justify-content: center;">
				<button
					class="btn-cash choose-payment-type-btn"
					style="flex: 0 1 auto;margin-top:5vh;"
					v-on:click="processingCharges=true;isChargesModalOpen=false;"
				>
					<i class="fas fa-usd-circle"></i> Cash
				</button>
				<!-- spacer -->
				<div style="flex: 1 1 auto;"></div>
				<button
					v-if="scanner.enable_square"
					class="choose-payment-type-btn"
					style="flex: 0 1 auto;margin-bottom:5vh;"
					v-on:click="isCardCharging=true;squareService.chargeAmount(partyTotal*100);"
				>
					<i class="fas fa-credit-card"></i> Card
				</button>
			</div>
		</div>

		<!--	Card charging waiting..	-->
		<div v-if="isCardCharging" class="processCharges fullscreen-centered always-on-top white-light minheight">
			<div>
				Waiting for Square response
				<br/>
				<br/>
				<loading-dots/>
			</div>
		</div>

		<ErrorPopup
			:show="shouldShowError"
			:error-title="errorTitle"
			:error-message="errorMessage"
			:btn-text="errorBtnTxt"
			:showProceedBtn="canProceedThroughErrors"
			@proceed="proceedWithNoDecals"
			@close="closeScan"
		/>
	</div>
</template>

<script>
import axios from 'axios';
import LoadingDots from "./icons_svg/LoadingDots.vue";
import PartyItemRow from "./PartyItemRow.vue";
import {SquareService} from "../squareservice.js";
import Logo from "@/components/Logo.vue";
import ColorHelper from "@/color-helper";
import ErrorPopup from "@/components/ErrorPopup.vue";
import AddUserPopup from "@/components/AddUserPopup.vue";

export default {
		name: 'ScanBatch',
		components: {
			AddUserPopup,
			ErrorPopup,
			PartyItemRow,
			LoadingDots,
			Logo
		},
		data() {
			return {
				isAddingUser: false,
				element: null,
				scanner: this.$scanner,
				partyId: this.$scanner.partyId,
				partyPaid: this.$scanner.partyPaid,
				partyTotal: 0,
				cashTaken: -1,
				cashGiven: 0,
				invalidFound: false,
				invalidError: 'Not Found',
				apiErrorFound: false,
				userFound: false,
				userId: '',
				scannedUser: {
					Name: '',
					Image: '',
					Ticket: [],
					Lodging: [],
					Decals: [],
					Access: [],
					IsReEntry: false,
					isFreeReentry: false,
				},
				amAdding: false,
				processingParty: false,
				disableSubmitParty: true,
				processingCharges: false,
				isChargesModalOpen: false,
				isCardCharging: false,
				decalOpen: false,
				decalDetails: {
					user: {},
				},
				loading: false,
				showWaiveFeesPopup: false,
				userIdWaivingFees: '',
				credentialIdWaivingFees: '',
				partyUsers: {
					'userId': this.partyUser,
				},
				partyUser: {
					user_id: '',
					user_name: '',
					user_image: '',
					user_entry_type: '',
					is_lodger_for_credential_id: null,
					user_ticket: '',
					user_lodging: '',
					access: {
					},
					decals: {
						'partyItemId': this.userDecal
					},
					entry_fees: {
						fees_total: 0,
						gst_total: 0,
						pst_total: 0,
						pre_waived_total: 0,
						total: 0,
						waivedFeeByCredentialId: '',
					},
					showWaivedFeesCheckbox: false,
					hasWaivedFees: false,
					entry_party_items: {
						credential_id: '',
						event_credential_type_id: '',
						party_item_id: '',
						user_id: '',
						waived_by_credential_id: '',
					},
					isWaivingFees: false,
					showFeeWaivedSuccess: false,
					isDecalAdding: false,
				},
				userDecal: {
					eventCredentialTypeBarcode: '',
					eventCredentialTypeId: '',
					eventCredentialTypeTitle: '',
					eventCredentialTypeSku: '',
					partyItemId: '',
					total: 0.00,
					user_can_remove: '',
					isRemoving: false,
				},
				curScanningUserID: 0,
				curScanningDecalPartyID: 0,
				squareService: null,
				colorHelper: new ColorHelper(),
				shouldShowError: false,
				errorTitle: "",
				errorMessage: "",
				errorBtnTxt: null,
				canProceedThroughErrors: false,
			}
		},
		beforeMount() {
			this.partyUsers = {}
		},
		async mounted() {
			this.partyId = this.$scanner.partyId
			this.partyPaid = this.$scanner.partyPaid
			this.partyTotal = 0
			window.doscan = this.doScan
			this.$scanner.loadParty = this.loadParty
			this.$scanner.openCharges = this.openCharges
			this.$scanner.closeCharges = this.closeCharges
			// Check for square params + act accordingly
			if (this.partyId) {
				window.scanner.loader.open()
				if(window.scanner.enable_square) {
					this.squareService = new SquareService(this.partyId);
					await this.squareService.checkForSquareReturnAndAct(this.squareSuccess, this.squareFailure);
				}
			}
			this.loadParty()
		},
		methods: {
			squareFailure(shouldKeepUrl, errorDescription) {
				alert(errorDescription);
				if (shouldKeepUrl) {
					// Keep the URL & try again if we get an error confirming card payment to MS
					location.reload();
					return;
				}
				window.location = window.location.href.split('?')[0];
			},
			squareSuccess() {
				// Reloading the page should bring the app to ProcessParty
				window.location = window.location.href.split('?')[0];
			},
			sortedUserList() {
				let allUsers = Object.values(this.partyUsers);

				const naturalCollator = new Intl.Collator();
				allUsers.sort((a, b) => naturalCollator.compare(a.user_name, b.user_name));
				return allUsers;
			},
			nonLodgingUsers() {
				let users = Object.values(this.partyUsers).filter(user => !user.is_lodger_for_credential_id);

				const naturalCollator = new Intl.Collator();
				users.sort((a, b) => naturalCollator.compare(a.user_name, b.user_name));
				return users;
			},
			showErrorMessage (errorMessage) {
				this.invalidError = errorMessage ? errorMessage : 'An error occurred, please try again.'
				this.invalidFound = true;
			},
			cancelParty(e) {
				if (e) { e.preventDefault(); }
				if (window.helpers.isFunction(this.$scanner.cancelBatch)) { this.$scanner.cancelBatch() }
			},
			doScan(e) {
				if (e) { e.preventDefault(); }
				this.isAddingUser = true;
				this.invalidFound = false;
				this.userFound = false;
			},
			closeScan() {
				this.isAddingUser = false;
				this.amAdding = false;
				this.invalidFound = false;
				this.userFound = false;
				this.shouldShowError = false;
				if(this.apiErrorFound) {
					window.location.reload();
				}
			},
			resetUserInfo() {
				this.userFound = false
				this.userId = ''
				this.scannedUser.Name = ''
				this.scannedUser.Image = ''
				this.scannedUser.Ticket = []
				this.scannedUser.Lodging = []
				this.scannedUser.Decals = []
				this.scannedUser.Access = []
				this.scannedUser.IsReEntry = false
				this.scannedUser.isFreeReentry = false
			},
			setUserInfo(user) {
				this.userId = user.user_id
				this.scannedUser.Name = user.user_name
				this.scannedUser.Image = user.user_image
				this.scannedUser.Ticket = user.user_authed_ticket
				this.scannedUser.Lodging = user.user_authed_lodging
				this.scannedUser.Decals = user.user_authed_decals
				this.scannedUser.Access = user.user_authed_access
				this.userFound = true;
			},
			updatePartyTotal() {
				this.partyTotal = 0.00;
				this.$scanner.availableDecalsMap && Object.values(this.partyUsers).map(user => {
					//Tally up Entry Fees
					user.entry_fees.forEach((fee) => {
						if(!fee.waivedFeeByUserId && !fee.waivedFeeByCredentialId) {
							this.partyTotal += parseFloat(fee.total);
						}
					})

					//Tally up Decals
					Object.values(user.decals).map(decal => {
						this.partyTotal += parseFloat(decal.total);
					})

					//Tally up Ticket purchased at gate
					if(user.user_ticket_to_purchase) {
						this.partyTotal += parseFloat(user.user_ticket_to_purchase.total);
					}
				})

				this.partyTotal = this.partyTotal.toFixed(2);
			},
			updateCollectMoneyValues() {
				if (this.cashTaken === -1) { this.cashTaken = this.partyTotal }
				const change = this.partyTotal - this.cashTaken
				this.cashGiven = (!isNaN(parseFloat(change))) ? parseFloat(change) * -1 : 0
			},
			parseDecalPayload(partyItem) {
				return {
					...this.userDecal,
					userId: partyItem.user_id,
					partyItemId: partyItem.party_item_id,
					credentialId: partyItem.credential_id,
					eventCredentialTypeId: partyItem.event_credential_type_id,
					eventCredentialTypeTitle: partyItem.event_credential_type_title,
					eventCredentialTypeSku: partyItem.event_credential_type_sku,
					eventCredentialTypeEffectiveScansForType: partyItem.event_credential_type_effective_scans_for_type ? partyItem.event_credential_type_effective_scans_for_type : '',
					total: parseFloat(partyItem.total).toFixed(2),
					user_can_remove: partyItem.user_can_remove,
				}
			},
			loadParty(e) {
				if (e) { e.preventDefault(); }
				window.scanner.loader.open()
				const scannerRegKey = localStorage.getItem('scanner_regkey');
				axios.defaults.headers.common['X-Auth-Token'] = scannerRegKey;
				axios.post(`${this.$scanner.api_server}/api/scannerdevice/party/${this.partyId}/loadPartyUsers`, {
					check: scannerRegKey,
					party_id: `${this.partyId}`,
				})
				.then(res => {
					if (res.status === 200) {
						const partyUsers = res.data.data;
						partyUsers.forEach((user) => {
							const userId = user.user_id;

							let access = {};
							user.access && user.access.forEach((partyItem) => {
								const partyItemId = partyItem.party_item_id;
								access[partyItemId] = this.parseDecalPayload(partyItem);
							});

							let decals = {};
							user.decals && user.decals.forEach((partyItem) => {
								const partyItemId = partyItem.party_item_id;
								decals[partyItemId] = this.parseDecalPayload(partyItem);
							});

							let userDetails = {
								user_id: userId,
								user_name: user.user_name,
								user_image: user.user_image,
								user_entry_type: user.user_entry_type,
								user_ticket: user.user_ticket,
								user_ticket_to_purchase: user.ticket_to_purchase,
								user_lodging: user.user_lodging,
								lodging_exchanges_for_decals: user.lodging_exchanges_for_decals,
								access: access,
								decals: decals,
								entry_fees: user.entry_fees,
								entry_party_items: user.entry_party_items,
								is_lodger_for_credential_id: user.is_lodger_for_credential_id,
							}

							this.partyUsers[userId] = {
								...this.partyUser,
								...userDetails
							}
						});
						this.updateWaivedFees();
						this.updatePartyTotal()
						this.$forceUpdate();
						this.$nextTick(() => {
							window.scanner.loader.close();
						})
						if(this.partyPaid) {
							this.$emit("partyPaid");
						}
					} else {
						window.debug('🎉Party: 🚫Party Not Loaded');
						window.debug(res.data);
						let error = res.data.error
						this.showErrorMessage(error.error_message)
						window.scanner.loader.close()
					}
				})
				.catch(err => {
					window.debug(err);
					this.apiErrorFound = true;
					this.showErrorMessage(err.response && err.response.data.message ? err.response.data.message : "Something went wrong loading the party")
					// 401 response here should deregister local scanner
					if (err.response && err.response.status === 401) {
						this.$emit('unregister');
					}
					window.debug('🎉Party: 🚫Error Connecting to Server for Party Loading');
					window.scanner.loader.close()
				});
			},
			updateWaivedFees() {
				//determines if the waive fee checkbox should be shown
				let allPartyUsers = Object.values(this.partyUsers);
				let allCredentials = {};
				allPartyUsers.forEach(user => {
					if(user.user_ticket) {
						allCredentials[user.user_ticket.id] = user.user_ticket;
					}
					if(user.user_lodging) {
						allCredentials[user.user_lodging.id] = user.user_lodging;
					}
					//Assumption: Decals cannot waive entry fees.
				})

				allPartyUsers.forEach(user => {
					if (user.entry_party_items.length > 0) {
						user.entry_party_items.forEach((entry_party_item) => {
							if(entry_party_item.waived_by_credential_id) {
								let waivedFees = user.entry_fees.filter(fee => fee.event_credential_type_id === entry_party_item.event_credential_type_id);
								waivedFees.forEach(fee => {
									fee.waivedFeeByCredentialId = entry_party_item.waived_by_credential_id;
									// fee.waivedFeeByUserId = allCredentials[entry_party_item.waived_by_credential_id].user_id;
									fee.waivedFeeByUserId = !!allCredentials[entry_party_item.waived_by_credential_id] && allCredentials[entry_party_item.waived_by_credential_id].user_id;
								})
								user.showWaivedFeesCheckbox = true;
								user.hasWaivedFees = true;
							}
						})

					// Failsafe to trigger checkbox showing state true when there is no entry fee available
					} else if (user.is_lodger_for_credential_id){
							user.showWaivedFeesCheckbox = true;
							// this has to be set true as well or else checkbox will say "waive entry fees?"
							//TODO previous comment seems to be incorrect
							user.hasWaivedFees = true;
					}
				})
			},
			processScan(code) {
				window.scanner.loader.open()

				const scannerRegKey = localStorage.getItem('scanner_regkey');
				axios.defaults.headers.common['X-Auth-Token'] = scannerRegKey;
				axios.post(`${this.$scanner.api_server}/api/scannerdevice/scan`, {
					check: scannerRegKey,
					code: code,
				})
				.then(res => {
					if (res.data.status.success) {
						const data = res.data.data;
						this.resetUserInfo()
						if (data.is_ga_blacklisted === true) {
							alert('This user must be checked in at Reception.');
						} else {
							if (data.user_found) {
								const userData = JSON.parse(data.user);
								if (userData.user_authed_ticket.length === 0) {
									alert('No claimed tickets found for this user. Ticket must be claimed in User Portal or by the Gate Supervisor.');
									return;
								}
								// Valid ticket found, set user data
								this.setUserInfo(userData)
								if (data.reentry) {
									this.scannedUser.IsReEntry = true;
									this.scannedUser.isFreeReentry = data.free_reentry;
								} else {
									this.scannedUser.IsReEntry = false;
									this.scannedUser.isFreeReentry = false;
								}
							}
						}
					} else {
						let error = res.data.error
						this.resetUserInfo()
						this.showErrorMessage(error.error_message)
					}
				})
				.catch(err => {
					this.resetUserInfo()

					let errMsg = "Error Connecting to Server for Scanning"
					if(err.response) {
						if(err.response.status === 417) {
							errMsg = JSON.parse(err.response.data.message).join(", <br>")
							this.errorTitle = "You are missing these items to give to the guest:"
							this.errorMessage = errMsg
							this.shouldShowError = true
							return
						} else if(err.response.data.message) {
							errMsg = err.response.data.message
						}
					}
					this.apiErrorFound = true;
					this.showErrorMessage(errMsg)
				})
				.finally(() => {
					this.isAddingUser = false;
					window.scanner.loader.close()
				});
			},
			addUserToParty(e) {
				if (e) { e.preventDefault(); }
				window.scanner.loader.open()
				window.debug('🎉Party: Adding User to Party');
				this.amAdding = true;

				const scannerRegKey = localStorage.getItem('scanner_regkey');
				axios.defaults.headers.common['X-Auth-Token'] = scannerRegKey;
				axios.post(`${this.$scanner.api_server}/api/scannerdevice/party/${this.partyId}/add`, {
					check: scannerRegKey,
					user_id: `${this.userId}`,
					ticket_id: (this.scannedUser.Ticket) ? `${this.scannedUser.Ticket.id}` : '',
					lodging_id: (this.scannedUser.Lodging) ? `${this.scannedUser.Lodging.id}` : '',
					decal_ids: (this.scannedUser.Decals) ? this.scannedUser.Decals.map((decal) => `${decal.id}`) : '',
					access_ids: (this.scannedUser.Access) ? this.scannedUser.Access.map((access) => `${access.id}`) : '',
				})
				.then(res => {
					if (res.status === 200) {
						window.debug('🎉Party: ✅User Added');
						const user = res.data.data;
						let access = {};
						user.access && user.access.forEach((partyItem) => {
							const partyItemId = partyItem.party_item_id;
							access[partyItemId] = this.parseDecalPayload(partyItem);
						});
						let decals = {};
						user.decals && user.decals.forEach((partyItem) => {
							const partyItemId = partyItem.party_item_id;
							decals[partyItemId] = this.parseDecalPayload(partyItem);
						});
						let userId = user.user_id;
						let userDetails = {
							user_id: userId,
							user_name: user.user_name,
							user_image: user.user_image,
							user_entry_type: user.user_entry_type,
							user_ticket: user.user_ticket,
							user_lodging: user.user_lodging,
							lodging_exchanges_for_decals: user.lodging_exchanges_for_decals,
							access: access,
							decals: decals,
							entry_fees: user.entry_fees,
							entry_party_items: user.entry_party_items,
							is_lodger_for_credential_id: user.is_lodger_for_credential_id,
						}
						this.partyUsers[userId] = {
							...this.partyUser,
							...userDetails
						}

						this.updateWaivedFees();
						this.updatePartyTotal();
						this.closeScan();
						this.$forceUpdate();
						window.scanner.loader.close();
					} else {
						window.debug('🎉Party: 🚫User Not Added');
						window.debug(res.data);
						let error = res.data.error
						this.showErrorMessage(error.error_message)
						window.scanner.loader.close()
					}
				})
				.catch(err => {
					console.log(err)
					window.scanner.loader.close()
					this.apiErrorFound = true
					this.showErrorMessage(err.response && err.response.data.message ? err.response.data.message : "Error adding the user")
				});
			},
			removeUser(userId) {
				if (confirm('Remove '+this.partyUsers[userId].user_name+'?')) {
					window.scanner.loader.open();
					window.debug('🎉Party: Removing User From Party');

					const scannerRegKey = localStorage.getItem('scanner_regkey');
					axios.defaults.headers.common['X-Auth-Token'] = scannerRegKey;
					axios.post(`${this.$scanner.api_server}/api/scannerdevice/party/${this.partyId}/removeUser/${userId}`, {
						check: scannerRegKey,
						user_id: userId,
					})
					.then(res => {
						if (res.status === 200) {
							window.debug('🎉Party: ✅User Removed');
							const userHadWaivedFee = this.partyUsers[userId].hasWaivedFees;
							delete this.partyUsers[userId];
							this.$forceUpdate();
							this.updatePartyTotal();
							window.scanner.loader.close()
							if(userHadWaivedFee) {
								this.loadParty()
							}
						} else {
							window.debug('🎉Party: 🚫User Not Removed');
							window.debug(res);
							let error = res.data.error
							this.showErrorMessage(error.error_message)
							window.scanner.loader.close()
						}
					})
					.catch(err => {
						window.debug(err);
						this.apiErrorFound = true;
						let error = err.response.data.message;
						if(this.confirmEarlyEntryNA()){
							error = "User is providing lodging access for party member, please remove access before removing user";
						}
						this.showErrorMessage(err.response && err.response.data.message ? error : "Error removing the user")
						window.scanner.loader.close()
					});
				}
			},
			openDecal(user_id) {
				this.decalDetails.user = this.partyUsers[user_id];
				this.decalOpen = true;
			},
			closeDecal() {
				this.decalDetails.user = null;
				this.decalOpen = false
			},
			addDecal(user_id, eventCredentialTypeId) {
				this.partyUsers[user_id].isDecalAdding = true; //shows loading dots
				this.closeDecal()
				let requestItems = [{
					user_id: user_id,
					event_credential_type_id: eventCredentialTypeId,
				}]

				const scannerRegKey = localStorage.getItem('scanner_regkey');
				axios.defaults.headers.common['X-Auth-Token'] = scannerRegKey;
				axios.post(`${this.$scanner.api_server}/api/scannerdevice/party/${this.partyId}/addItemsToParty`, {
					check: scannerRegKey,
					scanner_id: this.partyId,
					items: requestItems,
				})
				.then(res => {
					window.debug(res);
					if (res.status === 200) {
						window.debug('🎉Party: ✅Party Item Added For User');
						let data = res.data.data;

						Object.values(data).forEach((partyItem) => {
							const userId = partyItem.user_id;
							this.partyUsers[userId].decals[partyItem.party_item_id] = this.parseDecalPayload(partyItem);
						});
						this.updatePartyTotal()
					} else {
						this.showErrorMessage("There was a problem adding the Decal")
					}
				})
				.catch(err => {
					window.debug(err)
					this.apiErrorFound = true
					this.showErrorMessage(err.response && err.response.data.message ? err.response.data.message : "Error adding the decal")
				})
				.finally(() => {
					this.partyUsers[user_id].isDecalAdding = false;
				})
				;
			},
			removeDecal(removeDataObj) {
				const userId = removeDataObj['user.user_id'];
				const partyItemId = removeDataObj['decal.partyItemId'];
				this.partyUsers[userId].decals[partyItemId].isRemoving = true;
				this.$forceUpdate()

				//window.scanner.loader.open()
				let user = this.partyUsers[userId]
				let decalToRemove = this.partyUsers[userId].decals[partyItemId];

				axios.post(`${this.$scanner.api_server}/api/scannerdevice/party/${this.partyId}/removeItemsFromParty`, {
					check: `${localStorage.getItem('scanner_regkey')}`,
					scanner_id: this.partyId,
					party_items: [decalToRemove.partyItemId],
				})
				.then(res => {
					if (res.status === 200) {
						window.debug('🎉Party: ✅Party Item Remove For User');
						delete user.decals[partyItemId]
						this.$forceUpdate()
						this.updatePartyTotal()
					} else {
						this.showErrorMessage("There was a problem removing the Decal")
					}
					window.scanner.loader.close()
				})
				.catch(err => {
					window.debug(err)
					this.apiErrorFound = true
					this.showErrorMessage(err.response && err.response.data.message ? err.response.data.message : "Error removing the decal")
					window.scanner.loader.close()
				});
			},
			openWaiveFeesPopup(userIdWaivingFees, credentialIdWaivingFees) {
				this.showWaiveFeesPopup = true;
				this.userIdWaivingFees = userIdWaivingFees;
				this.credentialIdWaivingFees = credentialIdWaivingFees;
			},
			closeWaiveFeesPopup() {
				this.showWaiveFeesPopup = false;
				this.userIdWaivingFees = '';
				this.credentialIdWaivingFees = '';
			},
			addLodgingGuest(user) {
				window.scanner.loader.open()
				const userId = user.user_id;
				let userWaivingFees = this.partyUsers[this.userIdWaivingFees];
				this.showWaiveFeesPopup = false;

				axios.post(`${this.$scanner.api_server}/api/scannerdevice/party/${this.partyId}/addLodgerGuest`, {
					check: `${localStorage.getItem('scanner_regkey')}`,
					guest_user_id: userId,
					lodging_credential_id: this.credentialIdWaivingFees,
				})
				.then(res => {
					if (res.status === 200) {
						this.disableFeeWaiving();
						//Opted for an easy to maintain solution in the response handler here. See the previous commit for a working but more complex solution.
						this.loadParty()
						// Show waived fees success message
						userWaivingFees.showFeeWaivedSuccess = true;
						new Promise(resolve => setTimeout(resolve, 500)).then(() => {
							userWaivingFees.showFeeWaivedSuccess = false;
							this.$forceUpdate();
						});
					} else {
						this.disableFeeWaiving();
						this.loadParty()
						this.showErrorMessage("Unable to modify Entry Fees")
					}
				})
				.catch(err => {
					this.apiErrorFound = true
					this.showErrorMessage(err.response && err.response.data.message ? err.response.data.message : "Unable to modify Entry Fees")
				})
				.finally(() => {
					window.scanner.loader.close()
				});
			},
			removeLodgerGuest(user) {
				//show a progress loader
				window.scanner.loader.open()

				const userId = user.user_id;

				axios.post(`${this.$scanner.api_server}/api/scannerdevice/party/${this.partyId}/removeLodgerGuest`, {
					check: `${localStorage.getItem('scanner_regkey')}`,
					guest_user_id: userId,
					lodging_credential_id: user.is_lodger_for_credential_id,
				})
				.then(res => {
					if (res.status === 200) {
						this.disableFeeWaiving();
						//Opted for an easy to maintain solution in the response handler here. See the previous commit for a working but more complex solution.
						this.loadParty()
					} else {
						this.disableFeeWaiving();
						this.loadParty()
						this.showErrorMessage("Unable to modify Entry Fees")
					}
				})
				.catch(err => {
					this.apiErrorFound = true
					this.showErrorMessage(err.response && err.response.data.message ? err.response.data.message : "Unable to modify Entry Fees")
				})
				.finally(() => {
					window.scanner.loader.close()
				});
			},
			disableFeeWaiving() {
				Object.values(this.partyUsers).forEach(user => {
					let userHasWaivedFee = user.entry_fees.filter(fee => (!!fee.waivedFeeByUserId && !!fee.waivedFeeByCredentialId))
					user.showWaivedFeesCheckbox = !!userHasWaivedFee.length
					user.hasWaivedFees = !!userHasWaivedFee.length
				})
				this.userIdWaivingFees = '';
				this.credentialIdWaivingFees = '';
				this.$forceUpdate();
			},
			verifyCheckout(){
				let decalsFound = false;
				Object.values(this.partyUsers).forEach(user => {
					if (Object.values(user.decals).length || user.lodging_exchanges_for_decals.length > 0) {
						decalsFound = true;
					}
				});
				if (decalsFound) {
					this.openCharges();
				} else {
					this.errorTitle = "0 Parking Decals for Party";
					this.errorMessage = "Confirm with the party if they need a parking decal or not";
					this.errorBtnTxt = "Back";
					this.canProceedThroughErrors = true;
					this.shouldShowError = true;
				}
			},
			proceedWithNoDecals() {
				this.errorMessage = '';
				this.shouldShowError = false;
				this.errorBtnTxt = null;
				this.canProceedThroughErrors = false;
				return this.openCharges();
			},
			openCharges() {
				window.scanner.loader.open();
				this.updatePartyTotal();
				this.cashTaken = this.partyTotal;
				this.updateCollectMoneyValues();

				axios.post(`${this.$scanner.api_server}/api/scannerdevice/party/${this.partyId}/getPartyTotalPrice`, {
					check: `${localStorage.getItem('scanner_regkey')}`,
				})
				.then(res => {
					if (res.status === 200) {
						if(parseFloat(this.partyTotal).toFixed(2) !== parseFloat(res.data.data.total).toFixed(2)) {
							this.invalidError = 'There was a price discrepancy, please close the party and try again'
							this.invalidFound = true;
						} else {
							// Open the charge type modal
							// if $0 total, go to cash
							if (this.partyTotal > 0) {
								//If square is enabled, allow scanner to select payment method
								if(window.scanner.enable_square) {
									this.isChargesModalOpen = true;
								} else {
									this.processingCharges=true;
								}
							} else {
								this.processingCharges=true;
							}
						}
						window.scanner.loader.close()
					} else {
						window.debug(res);
						this.apiErrorFound = true;
						this.showErrorMessage('Unable to calculate party total price');
						window.scanner.loader.close()
					}
				})
				.catch(err => {
					this.apiErrorFound = true;
					this.showErrorMessage(err.response && err.response.data.message ? err.response.data.message : 'Unable to calculate party total price');
					window.scanner.loader.close()
				});
			},
			closeCharges() {
				this.processingCharges = false
			},
			checkoutParty() {
				if (isNaN(this.cashTaken) || Number(this.cashTaken) < Number(this.partyTotal)) {
					alert('Not enough cash taken.');
					return;
				}
				if (confirm(`Confirm collection of $${parseFloat(this.cashTaken).toFixed(2)} CASH? ${this.cashGiven ? "\n\nChange: $"+parseFloat(this.cashGiven).toFixed(2) : ""}`)) {
					this.closeCharges();
					window.scanner.loader.open()

					let checkoutPartyPayload = {
						payment_type: 'CASH',
						party_total: (this.partyTotal) ? this.partyTotal : 0,
						cash_taken: (this.cashTaken) ? this.cashTaken : 0,
						cash_given: (this.cashGiven) ? this.cashGiven : 0,
					}

					axios.post(`${this.$scanner.api_server}/api/scannerdevice/party/${this.partyId}/checkout`, {
						check: `${localStorage.getItem('scanner_regkey')}`,
						...checkoutPartyPayload,
					})
					.then(res => {
						window.debug(res);
						if (res.status === 201 || res.status === 208) {
							this.$emit("partyPaid");
						} else {
							window.debug('Party has not paid');
							window.debug(res.data);
							let error = res.data.error;
							this.invalidError = (error.error_message) ? error.error_message : 'Not Found'
							this.invalidFound = true;
						}
					})
					.catch(err => {
						window.debug(err)
						this.apiErrorFound = true
						this.showErrorMessage(err.response && err.response.data.message ? err.response.data.message : 'There was a problem with the party payment')
					})
					.finally(() => {
						window.scanner.loader.close()
					});
				}
			},
			async onInit(promise) {
				this.loading = true;
				// eslint-disable-next-line no-empty
				try {
					await promise
					// eslint-disable-next-line no-empty
				} catch (error) {
				} finally {
					this.loading = false;
				}
			},
			isUserALodgerGuest(user) {
				const userIsLodger = !!user.is_lodger_for_credential_id
				const doesNotOwnLodgerCred = user.user_lodging ? (user.user_lodging.id !== user.is_lodger_for_credential_id) : true
				return userIsLodger && doesNotOwnLodgerCred
			},
			userAccessThatRequiresScan: (user) => {
				return Object.values(user.access).filter((access) => !!access.eventCredentialTypeEffectiveScansForType)
			},
			determinePartyItemIconToDisplay: (ect) => {
				const eventCredentialTypeEffectiveScansForType = ect.eventCredentialTypeEffectiveScansForType ? ect.eventCredentialTypeEffectiveScansForType.toLowerCase() : '';
				switch(eventCredentialTypeEffectiveScansForType) {
					case 'rfid':
						return 'circle-notch'
					case 'barcode':
						return 'sticky-note'
					default:
						return 'id-badge'
				}
			},
			determinePartyItemColor: (eventCredentialTypeId) => {
				if(!eventCredentialTypeId) {
					return ''
				}
				const decal = window.scanner.availableDecalsMap[eventCredentialTypeId];
				return decal ? decal.color : '';
			},
			getUserImage(userImageStr) {
				return userImageStr ? `${window.scanner.api_server}/media/user/${(userImageStr)}` : '/images/default_user.jpg';
			},
			confirmEarlyEntryNA(){
				let check = true;
				Object.keys(this.partyUsers).forEach(key => {
					if (!check) {
						return;
					}
					if(this.partyUsers[key].entry_fees.find((fee) => fee.is_reentry_fee == false) !== undefined){
						check = false;
					}
				});
				return check;
			},
			getDecalTextColor(color) {
				let isLight = this.colorHelper.isLightColor(color)
				return isLight ? "black" : "white"
			},
			getLodgingCredTitle(lodgingCred) {
				return `${lodgingCred.event_credential_type.title}${lodgingCred.reservationSelectedSeat ? ` (${lodgingCred.reservationSelectedSeat})` : ''}`
			},
		}
	}
</script>

<style>
	.ScanBatch { width: 100%; height: 100%; position: fixed; }
	.ScanBatch .TopBar { position: fixed; top: 0px; width: 100%; height: 55px; box-shadow: 0px 3px 3px rgba(0,0,0,0.4); }
	.TopBar .close-party { color: var(--color-red); }
	.TopBar .party { font-size: 20px; padding: 18px 5px 0px 15px; font-weight: normal; letter-spacing: 1px; }
	.TopBar .total { padding: 25px 20px 15px 30px; font-size: 30px; border-bottom-left-radius: 80px; box-shadow: 0px 3px 3px rgba(0,0,0,0.4); }
	.ScanBatch .BottomBar { position: fixed; bottom: 0px; width: 100%; height: 65px; box-shadow: 0px -3px 3px rgba(0,0,0,0.4); }
	.ScanBatch .BottomBar button { margin-top: 0px; }
	.invalidUser h2 { text-transform: uppercase; color: var(--color-red) !important; }
	.invalidUser h5 { margin: 30px 0px; }
	.closeButton { position: absolute; top: 15px; left: 20px; font-size: 36px; color: var(--color-red) !important; }
	.closeButton a { color: var(--color-red) !important; }
	#ScanBatches .Scan .user-image { width: 150px; height: 150px; border-radius: 75px; border: 4px solid var(--color-purple); overflow: hidden; display: inline-block; margin: 20px auto 10px; }
	#ScanBatches .Scan .user-image img { object-fit: cover; min-width: 100%; min-height: 100%; }
	#ScanBatches .Scan .cred-title { padding-top: 4px; }
	.users-selected-creds { display: inline-block; text-align: center; }
	.users-selected-creds-list { display: flex; flex-direction: column; text-align: center; }
	.users-selected-creds-list .user-cred { display: inline-block; margin: 0.2em; align-self: center; }
	.cred-type { vertical-align: middle; text-align: left; }
	.cred-type .cred-title { font-size: 16px; }
	.cred-type .cred-sku { width:100%; display: flex; font-size: 14px; font-family:'Courier New', Courier, monospace, sans-serif; color: #333; letter-spacing: 1px; padding: 0px; margin-top: -5px; }
	.user-cred { display:flex; margin: 10px 0px 15px; }
	.user-cred i { font-size: 30px; width: 50px; vertical-align: middle; text-align: center;}
	#theParty { padding: 65px 0px 65px 0px; }
	#theParty .remove-party-user { display: inline-block; vertical-align: top; font-size: 25px; margin: 10px 15px 0px -5px; }
	#theParty .remove-party-user a { color: var(--color-red); }
	.aParty { max-height: 100%; overflow: auto; }
	.aParty ul { list-style: none; padding: 0px; margin: 0px; display: block; width: 100%; padding: 1em;}
	.aParty ul li { list-style: none; padding: 10px 0px 5px; margin: 0px; display: block; border: 0px; border-bottom: 1px solid #DDD; }
	.aParty .party-user-image { display: inline-block; vertical-align: top; width: 50px; height: 50px; border-radius: 25px; border: 3px solid var(--color-purple); overflow: hidden; display: inline-block; margin: 0px 15px 0px 0px; }
	.aParty .party-user-image img { object-fit: cover; min-width: 100%; min-height: 100%; }
	.aParty .party-user-info { margin-bottom: 0.25em;}
	.aParty .party-user-info h4 { font-size: 18px; margin-bottom: -5px; }
	.aParty .party-user-info .user-name { display: inline-block; line-height: 54px; font-size: 20px; padding-top: 2px;}
	.aParty .party-user-credentials { margin-top: 0;}
	.aParty .cred-type .cred-title { font-size: 12px; font-weight:700; font-family: 'Oswald', Tahoma, Verdana, sans-serif}
	.aParty .cred-type .cred-sku { font-size: 10px; }
	.aParty .user-cred { margin: 0; }
	.aParty .user-cred i { font-size: 20px; width: 20px;}
	.aParty .user-cred .decal-barcode {
		margin: 0 1.2em;
	}
	.aParty .user-cred .decal-barcode input{
		margin: 0;
		font-family: 'Raleway';
		font-size: 12px;
		height: 30px;
	}
	.aParty.popup-margins {
		padding: 1.5em 0 1em 0;
	}

	.processForm { margin-left: 1.6em; }
	.processForm input { font-size: 12px; height: 30px; }
	.processForm button { font-size: 16px; height: 30px; padding: 8px;}
	.good { background: var(--background-green); }
	.bad { background: var(--background-red); }
	.all-good-reentry { font-size: 16px; color: var(--color-green); }
	#chargeParty { display: inline-block; text-align: left; }
	#chargeParty h6 { line-height: 2em; }
	#chargeParty label { width: 100px; display: inline-block; }
	#chargeParty span { color: #000; }
	#chargeParty input.money { width: 100px; text-align: center; font-size: 22px; height: 2em; margin-top: -4px; padding: 2px;}
	#DecalAdd { text-align: center; padding: 0.5em 0; }
	#userDecalPopup button { font-size: 20px; }
	.decal-choice { padding: 20px 10px; }
	.decal-choice select {
		font-size: 16px;
		margin: 5px 0;
		width: 100%;
	}
	.remove-party-decal { display: inline-block; font-size: 25px; margin-right:15px; }
	.remove-party-decal a { color: var(--color-red); }
	.user-cred.decal.non-removable-decal {  }
	.red { background-color: var(--color-red); }
	.decal { display: inline-block;}
	/* .item-price { text-align: right; margin: -15px 15px 15px 0px; } */
	.ml-2 { margin-left: 2em; }
	.waive-fee {
		font-size: 18px;
		text-align:right;
		margin-right: .5em;
	}

	.form-control {
		line-height: 1.1;
		display: grid;
		grid-template-columns: 12em auto;
	}

	input[type="checkbox"] {
		/* Add if not using autoprefixer */
		-webkit-appearance: none;
		/* Remove most all native input styles */
		appearance: none;
		/* For iOS < 15 */
		background-color: white;
		/* Not removed via appearance */
		margin: 0;

		font: inherit;
		color: var(--color-orange);
		width: 1.25em;
		height: 1.25em;
		border: 0.15em solid var(--color-orange);
		border-radius: 0.15em;
		transform: translateY(-0.075em);

		display: grid;
		place-content: center;
	}

	input[type="checkbox"]::before {
		content: "";
		width: 0.65em;
		height: 0.65em;
		clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
		transform: scale(0);
		transform-origin: bottom left;
		transition: 120ms transform ease-in-out;
		box-shadow: inset 1em 1em var(--color-orange);
		/* Windows High Contrast Mode */
		background-color: var(--color-orange);
	}

	input[type="checkbox"]:checked::before {
		transform: scale(1);
	}

	input[type="checkbox"]:focus {
		border: 0.15em solid var(--color-orange);
	}

	#DecalAdd button, .waive-fees-btn {
		font-size: 20px;
		margin: 0;
		margin-bottom: 0.75em;
		padding: 8px 10px;
		/* 2em looks better on a physical device, 1.75em looks better on a PC */
		height: 2em;
	}

	/* Looks better on a physical device, not a PC */
	#Collect, #Scan {
		height: 1.75em;
		padding-top: 6px;
	}

	.process-party-total {
		font-size: 16px;
		padding-top: 1em;
		text-align: center;
	}

	.centered-content {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.manualInput {
		height: 2.4em;
	}
</style>

<style scoped>
.loading-indicator {
	font-weight: bold;
	margin-top: 200px;
	font-size: 2rem;
	text-align: center;
}
.orange {
	color: var(--color-orange);
}
.party-item-header {
		padding-top:.4em;
}
.v-leave-active {
    transition: opacity 1s ease;
}
.v-leave-to {
    opacity: 0;
}
.btn-cash {
	background: #41b883 !important;
}
.choose-payment-type-btn {
	width: 70vw;
	height: 40vw;
}

.temp-user-id {
	color: coral;
	font-size: 16px !important;
	text-align: right;
}
</style>
